import React, { useContext } from 'react';
import MerchantWarehouseTable from './MerchantWarehouseTable';
import { CommonContext, MerchantWarehouseContext } from '../../context';
import { Box, Button, CardHeader, Paper, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import AlertMessage from '../common/AlertMessage';
import Loader from '../common/Loader';
import AddModal from './AddModal';
import FilterBar from './FilterBar';
import { useNavigate } from 'react-router-dom';

export default function MerchantWarehouseScreenview() {
    const { openAlert } = useContext(CommonContext);
    const { isLoading, handleAddModal, warehouseInfo } = useContext(MerchantWarehouseContext);
    const navigate = useNavigate();

    return (
        <div className='main-screen'>
            {openAlert && <AlertMessage />}
            {isLoading && <Loader />}
            <AddModal />

            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-start' }}>
                <Button
                    variant="outlined"
                    className="action-btn"
                    onClick={() => navigate('/master-warehouse')}
                    startIcon={<ArrowBack />}
                >
                    Back to Warehouse Master
                </Button>
            </Box>

            <Box className="component-header">
                <CardHeader
                    title={
                        <span>
                            Assigned Merchants {warehouseInfo && <span style={{ fontSize: '18px', color: '#333', fontWeight: 600 }}>- {warehouseInfo.name}</span>}
                        </span>
                    }
                />
                <Box className="action-btns-group">
                    <Button variant="outlined" className="action-btn" onClick={handleAddModal}>
                        Assign Merchant
                    </Button>
                </Box>
            </Box>
            <Paper sx={{ boxShadow: 'none' }}>
                <FilterBar />
                <MerchantWarehouseTable />
            </Paper>
        </div>
    );
}
